import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Button } from "react-bootstrap";
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import WidgetSettings from "./widgetsettings"
import { selectionTypes } from '../../utils/consts';
import { DataGrid, Column, ColumnChooser, Paging, Sorting, SearchPanel, Scrolling, FilterRow, Pager, Lookup, StateStoring, Selection, Toolbar, Item } from 'devextreme-react/data-grid';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from "devextreme/data/array_store";
import MonitorService from 'src/controllers/MonitorService';
import ChatsService from 'src/controllers/ChatController';
import InteractionMailModal from 'src/components/misc/interactionMailModal';
import InteractionMessagesModal from 'src/components/misc/interactionmessagesmodal';
import ViewChatCellRenderer from './queuedchats/viewchatcellrenderer';
import TransferButtonRenderer from './queuedchats/transferbuttonrenderer';
import ChannelIconRenderer from './queuedchats/channeliconrenderer';
import { faMessageLines } from '@fortawesome/pro-solid-svg-icons';
import OutgoingChat from 'src/components/chat/outgoingchat';
import InternalChat from 'src/components/chat/internalchat';
import NewChatMenu from 'src/components/chat/newchatmenu';
import NewEmail from 'src/components/chat/newemail';
import Closemultipleconfirm from "src/components/chat/closemultipleconfirm";
import Toastr from 'src/components/utils/toastr';
import TransferMultiple from "src/components/chat/transfermultiple";
const channels = [
    { id: "CHAT", name: "Fidelity" },
    { id: "FACEBOOK", name: 'Facebook' },
    { id: "TWITTER", name: 'X' },
    { id: "INSTAGRAM", name: 'Instagram' },
    { id: "WHATSAPP", name: 'WhatsApp' },
    { id: "RAINBOW", name: 'Rainbow' },
    { id: "TELEGRAM", name: 'Telegram' },
    { id: "MAIL", name: 'email' },
    { id: "GENERIC", name: 'generic' },
];


const GridRenderer = React.memo(({ dataSource, onEditorPreparing, onSelectionChanged, manageInteractions, toggleTransferChat, selected,
    toggleConfirmation, wrapperRef, toggleChat, showChat, toggleOugoingChatsModal, toggleInternalChatModal, toggleNewEmail, interactionClick, t, userId, token, isTransferAsync }) => {
    return <DataGrid
        id="queuedchatstableinbox"
        dataSource={dataSource}
        showBorders={false}
        repaintChangesOnly={true}
        columnAutoWidth={true}
        height={"74vh"}
        width={"100%"}
        allowColumnResizing={true}
        rowAlternationEnabled={true}
        loadPanel={{ enabled: false }}
        onEditorPreparing={onEditorPreparing}
        onSelectionChanged={onSelectionChanged}>
        <Sorting mode={"single"} />
        <Scrolling mode={"standard"} />
        <Column dataField="id" visible={false} showInColumnChooser={false} />
        <Column cssClass={"align-middle"} visible={manageInteractions} dataField="transfer" caption={""} showInColumnChooser={false} width={100} cellRender={e => <TransferButtonRenderer
            data={e.data}
            userId={userId}
            token={token}
        />} allowFiltering={false} alignment="center" />
        <Column cssClass={"align-middle"} dataField="channel" caption={t("channel")} width={100} cellRender={e => <ChannelIconRenderer value={e.value} />} alignment="center">
            <Lookup className="field-customization"
                dataSource={channels}
                valueExpr="id"
                displayExpr={e => {
                    return t(e.name);
                }}
            />
        </Column>
        <Column cssClass={"align-middle"} dataField="text" caption={t("message")} visible={true} width={350} />
        <Column cssClass={"align-middle"} dataField="queueDate" caption={t("datetime")} dataType={"datetime"} visible={true} width={350} />
        <Column cssClass={"align-middle"} dataField="from" caption={t("from")} visible={true} width={350} />
        <Column cssClass={"align-middle"} dataField="groupName" caption={t("group")} visible={true} width={350} />
        <Column
            dataField="waitingTime"
            caption={t("waitingtime")}
            dataType="datetime"
            format={"HH:mm:ss"}
            sortOrder="asc"
            width={160}
        />
        <SearchPanel
            visible={true}
            width={240}
            placeholder={t("search")}
        />
        <Toolbar>
            {
                manageInteractions &&
                <Item location="after" locateInMenu="auto">
                    {
                        isTransferAsync &&
                        <Button variant="light-primary" size="xs" onClick={toggleTransferChat} title={t("transfer")} disabled={selected.length === 0}>
                            <FontAwesomeIcon icon={duotone("arrow-right-arrow-left")} />
                        </Button>
                    }
                    {
                        !isTransferAsync &&
                        <div></div>
                    }
                </Item>
            }
            {
                manageInteractions &&
                <Item location="after" locateInMenu="auto">
                    <Button variant="light-danger" size="xs" onClick={toggleConfirmation} disabled={selected.length === 0}>
                        <FontAwesomeIcon icon={solid("xmark-large")} />
                    </Button>
                </Item>
            }
            <Item location="after" locateInMenu="auto">
                <Button
                    ref={wrapperRef}
                    variant='light-primary' size="xs" onClick={toggleChat}>
                    <FontAwesomeIcon icon={faMessageLines} />
                </Button>
                <NewChatMenu invoker={wrapperRef}
                    toggleChat={toggleChat}
                    show={showChat}
                    toggleOugoingChatsModal={toggleOugoingChatsModal}
                    toggleInternalChatModal={toggleInternalChatModal}
                    toggleNewEmail={toggleNewEmail}></NewChatMenu>

            </Item>
        </Toolbar>
        <Column cssClass={"align-middle"} dataField="chatGuid" caption={""} width={100} cellRender={e => <ViewChatCellRenderer
            data={e.data}
            onClickHandler={interactionClick}
            t={t}
        />} allowFiltering={false} alignment="center" />
        <ColumnChooser enabled={false} mode={"select"} allowSearch={true} />
        <FilterRow visible={true} applyFilter={"auto"} className={"form-control"} />
        <Pager
            showPageSizeSelector={true}
            allowedPageSizes={[5, 9, 12, 15]}
            showInfo={true}
            showNavigationButtons={true}
            infoText={t("pager")}
        />
        <Paging defaultPageSize={12} />
        <StateStoring
            enabled={true}
            type="localStorage"
            storageKey={`fcinbox_${localStorage.getItem("faUserId")}`}
        />
        <Selection enabled={manageInteractions} mode={"multiple"} />
    </DataGrid>

})
class QueuedChatsInbox extends Component {

    constructor(props) {
        super(props);
        let selectedGroups = localStorage.getItem(`QueuedChats_groups_${this.props.userId}`);
        this.store = new ArrayStore({
            key: "guid",
            data: []
        });

        this.dataSource = new DataSource({
            store: this.store,
            reshapeOnPush: true
        });
        this.lastUpdate = new Date();
        this.lastUpdate.setMinutes(this.lastUpdate.getMinutes() - 1);
        this.state = {
            showSettings: false,
            selectedGroups: selectedGroups ? JSON.parse(selectedGroups) : [],
            showInteraction: false,
            interaction: null,
            showInteractionMail: false,
            emailMessageNumber: null,
            iframeUrl: '',
            channel: localStorage.getItem(`QueuedChats_channel_${this.props.userId}`) || "",
            channelName: localStorage.getItem(`QueuedChats_channelName_${this.props.userId}`) || "",
            selected: [],
            showChat: false,
            showOutgoingChats: false,
            showInteralChat: false,
            showNewEmail: false,
            showConfirmation: false,
            showTransferChat: false,
            isTransferAsync: false
        };

        this.updateState = this.updateState.bind(this);
        this.selectGroups = this.selectGroups.bind(this);
        this.toggleSettings = this.toggleSettings.bind(this);
        this.toggleInteraction = this.toggleInteraction.bind(this);
        this.interactionClick = this.interactionClick.bind(this);
        this.toggleInteractionMail = this.toggleInteractionMail.bind(this);
        this.setGroupsAndChannel = this.setGroupsAndChannel.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.toggleChat = this.toggleChat.bind(this);
        this.toggleOugoingChatsModal = this.toggleOugoingChatsModal.bind(this);
        this.toggleInternalChatModal = this.toggleInternalChatModal.bind(this);
        this.toggleNewEmail = this.toggleNewEmail.bind(this);
        this.toggleConfirmation = this.toggleConfirmation.bind(this);
        this.toggleTransferChat = this.toggleTransferChat.bind(this);



        this.wrapperRef = React.createRef();
        this.toastrRef = React.createRef();

    }
    toggleSettings() {
        this.setState({
            showSettings: !this.state.showSettings
        });
    }

    selectGroups(groups) {

        this.setState({
            groups: groups,
            showSettings: !this.state.showSettings
        });

        localStorage.setItem(`QueuedChats_groups_${this.props.userId}`, JSON.stringify(groups));
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/queuedchats", {}, JSON.stringify({
                token: this.props.token,
                groupsIds: groups
            }));
        }

    }

    setGroupsAndChannel(groups, channel, channelName) {
        this.setState({
            groups: groups,
            showSettings: !this.state.showSettings,
            channel: channel,
            channelName: channelName
        });

        localStorage.setItem(`QueuedChats_groups_${this.props.userId}`, JSON.stringify(groups));
        localStorage.setItem(`QueuedChats_channel_${this.props.userId}`, channel);
        localStorage.setItem(`QueuedChats_channelName_${this.props.userId}`, channelName);

        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/queuedchats", {}, JSON.stringify({
                token: this.props.token,
                groupsIds: groups
            }));
        }

    }

    updateState(chats) {
        var data = JSON.parse(chats.body);
        var chn = localStorage.getItem(`QueuedChats_channel_${this.props.userId}`);

        if (chn !== null && chn !== "")
            data = data.filter(x => x.channel.toLowerCase() === chn.toLowerCase());

        data.forEach(v => {
            var queueDate = new Date();
            queueDate.setSeconds(queueDate.getSeconds() - v.timeWaiting);
            queueDate.setMilliseconds(1);
            var diff = v.timeWaiting;
            v.queueDate = queueDate;
            var t = new Date(1970, 0, 1);
            t.setSeconds(diff);
            v.waitingTime = t;
        });

        let callIds = this.dataSource.items().map(x => x.guid);

        const changes = [];
        callIds.forEach(x => {
            if (data.map(c => c.guid).indexOf(x) === -1) {
                changes.push({ type: 'remove', key: x });
            }

        });

        data.forEach(v => {
            if (callIds.indexOf(v.guid) > -1) {
                changes.push({ type: 'update', key: v.guid, data: v });
            } else {
                changes.push({ type: 'insert', key: v.guid, data: v });
            }

        });

        if (changes.length)
            this.dataSource.store().push(changes);
    }

    componentDidMount() {

        let selectedGroups = JSON.parse(localStorage.getItem(`QueuedChats_groups_${this.props.userId}`) || "[]");
        this.setState({
            selectedGroups: selectedGroups,
        });
        ChatsService.isTransferAsync(this.props.tenantId, res => {
            this.setState({
                isTransferAsync: res.data
            });
        });
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/queuedchats", {}, JSON.stringify({
                token: this.props.token,
                groupsIds: selectedGroups
            }));

            MonitorService.stompClient.subscribe(`/user/${this.props.token}/topic/queuedchats/`, this.updateState, { id: "queuedchats" });
        }
    }

    componentWillUnmount() {

        if (this.dataSource?.dispose) {
            this.dataSource.dispose();
        }
        if (this.store?.clear) {
            this.store.clear();
        }
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/unsubscribe/queuedchats", {}, JSON.stringify({
                token: this.props.token,
            }));

            MonitorService.stompClient.unsubscribe("queuedchats");
        }
    }
    toggleInteractionMail = e => {
        this.setState({ showInteractionMail: !this.state.showInteractionMail });

    }


    toggleInteraction = e => {
        this.setState({ showInteraction: !this.state.showInteraction });
    }

    interactionClick = (chatGuid) => {

        ChatsService.getChatByGuid(chatGuid, res => {
            if (res.data) {
                if (res.data.type.toLowerCase() === "mail") {
                    const emailMessageNumber = res.data.messages[0].messageId
                    const inbox = res.data.messages[0].inbox
                    const data = JSON.parse(localStorage.getItem("fc-logged"));
                    const rcu = localStorage.getItem("faRCUser");
                    const rcp = localStorage.getItem("faRCPwd");
                    const roundcubeUrl = localStorage.getItem("faRC");

                    var url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${data.tenantName}&agentId${this.props.userId}&_task=mail&_action=show&_uid=${emailMessageNumber}&_mbox=${inbox}&_fainbox=1`
                    res.data.channel = res.data.type;

                    this.setState({
                        emailMessageNumber: emailMessageNumber,
                        iframeUrl: url,
                        showInteractionMail: true,
                        interaction: res.data
                    });

                } else {
                    res.data.channel = res.data.type;
                    this.setState({
                        showInteraction: true,
                        interaction: res.data
                    });

                }
            }
        });
    }

    //TRLAMPA NIVEL DEUS
    onEditorPreparing = (e) => {
        if (e.parentType === "filterRow" && e.dataField === "waitingTime") {
            e.editorName = "dxDateBox";
            e.editorOptions = {
                type: "time",
                displayFormat: "HH:mm:ss",
                value: e.editorOptions.filterValue ? new Date(1970, 0, 1, 0, 0, e.editorOptions.filterValue) : null,
                onValueChanged: (args) => {
                    if (args.value) {
                        if (args.value instanceof Date) {
                            e.setValue(args.value);
                        }
                    } else {
                        e.setValue(null);
                    }
                },
            };
        }
    }

    onSelectionChanged(e) {
        this.setState({ selected: e.selectedRowsData });
    }
    toggleChat = e => {
        this.setState({ showChat: !this.state.showChat });
    }

    toggleOugoingChatsModal = e => {
        if (e)
            e.preventDefault();
        this.setState({
            showOutgoingChats: !this.state.showOutgoingChats,
            showChat: false
        });
    }

    toggleInternalChatModal = e => {
        if (e)
            e.preventDefault();
        this.setState({
            showInteralChat: !this.state.showInteralChat,
            showChat: false
        });
    }

    toggleNewEmail = e => {
        if (e)
            e.preventDefault();
        var ls = JSON.parse(localStorage.getItem("fc-logged"));
        var rcu = localStorage.getItem("faRCUser");
        var rcp = localStorage.getItem("faRCPwd");
        var roundcubeUrl = localStorage.getItem("faRC");

        var url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${ls.tenantName}&_task=mail&_action=compose&_extwin=1&_agentId=${this.props.userId}&_faagtinbox=1`
        window.open(url, "_blank", "toolbar=no, location=no, directories=no,status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=1024, height=600");
        this.setState({
            showChat: false
        });
    }

    toggleConfirmation = e => {
        this.setState({ showConfirmation: !this.state.showConfirmation });
    }
    toggleTransferChat = e => {
        //e.preventDefault();
        this.setState({ showTransferChat: !this.state.showTransferChat });
    }

    render() {
        return (
            <div className='position-relative' style={{ top: 10 }}>

                <GridRenderer
                    dataSource={this.dataSource}
                    onEditorPreparing={this.onEditorPreparing}
                    onSelectionChanged={this.onSelectionChanged}
                    manageInteractions={this.props?.functions?.manageInteractions || false}
                    toggleTransferChat={this.toggleTransferChat}
                    selected={this.state.selected}
                    toggleConfirmation={this.toggleConfirmation}
                    toggleChat={this.toggleChat}
                    wrapperRef={this.wrapperRef}
                    showChat={this.state.showChat}
                    toggleOugoingChatsModal={this.toggleOugoingChatsModal}
                    toggleInternalChatModal={this.toggleInternalChatModal}
                    toggleNewEmail={this.toggleNewEmail}
                    interactionClick={this.interactionClick}
                    userId={this.props.userId}
                    token={this.props.token}
                    t={this.props.t}
                    isTransferAsync={this.state.isTransferAsync} />

                <WidgetSettings showSettings={this.state.showSettings} toggleSettings={this.toggleSettings} token={this.props.token} setGroupsAndChannel={this.setGroupsAndChannel} groups={this.state.selectedGroups} selectionType={selectionTypes.MESSAGESQUEUE}></WidgetSettings>
                <InteractionMailModal show={this.state.showInteractionMail} toggleModal={this.toggleInteractionMail} interaction={this.state.interaction} url={this.state.iframeUrl}></InteractionMailModal>
                <InteractionMessagesModal show={this.state.showInteraction} toggleModal={this.toggleInteraction} interaction={this.state.interaction}></InteractionMessagesModal>

                <OutgoingChat show={this.state.showOutgoingChats} toggleModal={this.toggleOugoingChatsModal}></OutgoingChat>
                <InternalChat show={this.state.showInteralChat} toggleModal={this.toggleInternalChatModal}></InternalChat>
                <NewEmail show={this.state.showNewEmail} toggleModal={this.toggleNewEmail}></NewEmail>
                <Closemultipleconfirm show={this.state.showConfirmation} toggleModal={this.toggleConfirmation} conversations={this.state.selected} />
                <TransferMultiple show={this.state.showTransferChat} toggleModal={this.toggleTransferChat} conversations={this.state.selected} />
                <Toastr ref={this.toastrRef} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
        functions: state.agent.functions,
        tenantId: state.agent.tenantId
    };
};
export default compose(connect(mapStateToProps, null), withTranslation())(QueuedChatsInbox);